import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormControl, Select, MenuItem, Box } from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import CloseIcon from '@mui/icons-material/Close';

const SimulationHistorySelect = ({
  simulationHistory,
  selectedSimulationId,
  onSelectSimulation,
  removeSimulationHistory,
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  
  if (!simulationHistory?.length) return null;
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '12px 16px',
        marginBottom: '16px',
        backgroundColor: '#f8fafc',
        borderRadius: '8px',
        border: '1px solid #e2e8f0',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mr: 2 }}>
        <HistoryIcon sx={{ fontSize: 20, color: '#64748b' }} />
        <span style={{ fontSize: '0.9rem', color: '#64748b', fontWeight: 500 }}>
          {t('simulation.result.history.title')}
        </span>
      </Box>
      <FormControl size="small" sx={{ minWidth: 280 }}>
        <Select
          id="simulation-history-select"
          value={selectedSimulationId}
          onChange={onSelectSimulation}
          displayEmpty
          open={open}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          sx={{ fontSize: '0.9rem', backgroundColor: 'white' }}
        >
          <MenuItem value="">
            <em>{t('simulation.result.history.selectSimulation')}</em>
          </MenuItem>
          {simulationHistory.map((simu) => (
            <MenuItem
              key={simu.jobId}
              value={simu.jobId}
              sx={{
                fontSize: '0.9rem',
                fontWeight: simu.isCurrent ? 600 : 'normal',
                backgroundColor: simu.isCurrent ? 'rgba(25, 118, 210, 0.08)' : 'transparent',
              }}
            >
              {simu.isCurrent && (
                <Box component="span" sx={{ mr: 1, color: 'primary.main', fontWeight: 'bold' }}>
                  ●
                </Box>
              )}
              {simu.label}
              {open && simulationHistory.length > 1 && (
                <Box
                  component="span"
                  onClick={(e) => {
                    e.stopPropagation();
                    removeSimulationHistory(simu.jobId);
                  }}
                  sx={{
                    ml: 'auto',
                    display: 'flex',
                    color: '#94a3b8',
                    '&:hover': { color: 'error.main' },
                    cursor: 'pointer',
                  }}
                >
                  <CloseIcon fontSize="small" />
                </Box>
              )}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default SimulationHistorySelect;
